class WolfEquipNavigation {
  constructor(root) {
    this.root = root;
    this.items = root.querySelectorAll('.wolfequip-navigation__item--has-menu');
    this.bindEvents();
  }

  bindEvents() {
    this.items.forEach((item) => {
      const details = item.querySelector('details.wolfequip-mega-menu');
      if (!details) return;

      item.addEventListener('mouseenter', () => this.open(details));
      item.addEventListener('mouseleave', () => this.close(details));
      item.addEventListener('focusin', () => this.open(details));
      item.addEventListener('focusout', (event) => {
        if (!item.contains(event.relatedTarget)) this.close(details);
      });
    });
  }

  open(activeDetails) {
    this.items.forEach((item) => {
      const details = item.querySelector('details.wolfequip-mega-menu');
      if (details && details !== activeDetails) this.close(details);
    });

    activeDetails.setAttribute('open', '');
    activeDetails.querySelector('summary')?.setAttribute('aria-expanded', 'true');
  }

  close(details) {
    details.removeAttribute('open');
    details.querySelector('summary')?.setAttribute('aria-expanded', 'false');
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('.wolfequip-navigation').forEach((root) => new WolfEquipNavigation(root));
});
